import React from 'react'

const Timetable = () => (
  <section id="timetable" className="timetable">
    <div className="container">
      <h2 className="section-title">
        【スケジュール】
        <br />
        <span className="help">※参加企業数によって前後する場合あり</span>
      </h2>
      <div className="section-body">
        <div className="content valign-wrapper">
          <h4 className="content__num">１</h4>
          <span className="content__time">12:20〜13:00</span>
          <h3 className="content__name">受付</h3>
        </div>
        <div className="triangle">
          <i className="material-icons-outlined">
            signal_cellular_4_bar
          </i>
        </div>
        <div className="content valign-wrapper">
          <h4 className="content__num">２</h4>
          <span className="content__time">13:00〜13:15</span>
          <h3 className="content__name">企業紹介</h3>
        </div>
        <div className="triangle">
          <i className="material-icons-outlined">
            signal_cellular_4_bar
          </i>
        </div>
        <div className="content valign-wrapper">
          <h4 className="content__num">３</h4>
          <span className="content__time">13:15〜14:15</span>
          <h3 className="content__name">企業説明会</h3>
        </div>
        <div className="triangle">
          <i className="material-icons-outlined">
            signal_cellular_4_bar
          </i>
        </div>
        <div className="content valign-wrapper">
          <h4 className="content__num">４</h4>
          <span className="content__time">14:20〜17:00</span>
          <h3 className="content__name">座談会</h3>
        </div>
        <div className="triangle">
          <i className="material-icons-outlined">
            signal_cellular_4_bar
          </i>
        </div>
        <div className="content valign-wrapper">
          <h4 className="content__num">５</h4>
          <span className="content__time">17:30〜18:00</span>
          <h3 className="content__name">
            面接力UP講座
            <br/>
            <span className="help">※希望者のみ</span>
          </h3>
        </div>
      </div>
    </div>    
  </section>
)

export default Timetable